import { createContext, useContext } from 'react';

export type ProcessFormWizardContextType = {
    isAdmin: boolean;
};

export const ProcessFormWizardContext = createContext<ProcessFormWizardContextType>({
    isAdmin: false,
});

export function useProcessFormWizard() {
    return useContext(ProcessFormWizardContext);
}
